export class StorageAccountInfo {
    storageAccountName: string;
    storageAccountTags: Map<string, string>;

  constructor(name: string, tags: Map<string, string> ) {
    this.storageAccountName = name;
    this.storageAccountTags = tags;
  }
}
